@if (dataVisible$ | async) {
    @if (formGroup.controls.rendementsGrondslag.value !== 0 && formGroup.controls.rendementsGrondslag.value !== null &&
    formGroup.controls.rendementsGrondslag.value !== undefined) {
        <form [formGroup]="formGroup">
            <div class="row">
                <div class="col col-1 pt-3">
                    Bankrekeningen Nederland
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="banktegoedenNederland"
                            id="banktegoedenNederland"
                            label="Grondslag"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="rendementBanktegoedenNederland"
                            id="banktegoedenNederland"
                            label="Forfaitair rendement"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                    @if (heeftOwr) {
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementBankrekeningenNederland"
                                id="rendementBankrekeningenNederland"
                                label="Werkelijk rendement"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    }
                </div>
                <div class="col-3"></div>
            </div>

            @if (formGroup.get('banktegoedenBuitenland')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Bankrekeningen buitenland
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="banktegoedenBuitenland"
                                id="banktegoedenBuitenland"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementBanktegoedenBuitenland"
                                id="banktegoedenNederland"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementBankrekeningenBuitenland"
                                    id="rendementBankrekeningenNederland"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('beleggingen')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Beleggingen
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="beleggingen"
                                id="beleggingen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementBeleggingen"
                                id="rendementBeleggingen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementEffecten"
                                    id="rendementEffecten"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('groeneBeleggingenBanktegoeden')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Groene banktegoeden
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="groeneBeleggingenBanktegoeden"
                                id="groeneBeleggingenBanktegoeden"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementBanktegoedenGroenNederland"
                                id="rendementBanktegoedenGroenNederland"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementBankrekeningenGroen"
                                    id="rendementBankrekeningenGroen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('groeneBeleggingenEffecten')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Groene beleggingen
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="groeneBeleggingenBanktegoeden"
                                id="groeneBeleggingenBanktegoeden"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementBeleggingenGroen"
                                id="rendementBeleggingenGroen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementEffectenGroen"
                                    id="rendementEffectenGroen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('vrijstellingGroeneBeleggingen')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: Vrijstelling groene banktegoeden/beleggingen
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="vrijstellingGroeneBeleggingen"
                                id="vrijstellingGroeneBeleggingen"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            }

            @if (formGroup.get('onroerendeZakenNederland')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Onroerende zaken in Nederland
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="onroerendeZakenNederland"
                                id="onroerendeZakenNederland"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementOnroerendeZakenNederland"
                                id="rendementOnroerendeZakenNederland"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementOnroerendeZakenNl"
                                    id="rendementOnroerendeZakenNl"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('onroerendeZakenBuitenland')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Onroerende zaken in het buitenland
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="onroerendeZakenBuitenland"
                                id="onroerendeZakenBuitenland"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementOnroerendeZakenNederland"
                                id="rendementOnroerendeZakenNederland"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementOnroerendeZakenNl"
                                    id="rendementOnroerendeZakenNl"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('crytoBezittingen')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Cryptobezittingen
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="crytoBezittingen"
                                id="vorderingen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementCrypto"
                                id="rendementCrypto"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementCrypto"
                                    id="rendementCrypto"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('vorderingen')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Vorderingen
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="vorderingen"
                                id="vorderingen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementVorderingen"
                                id="rendementVorderingen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementVorderingen"
                                    id="rendementVorderingen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('periodiekeUitkeringen')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Periodieke uitkeringen
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="periodiekeUitkeringen"
                                id="periodiekeUitkeringen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementPeriodiekeUitkeringen"
                                id="rendementPeriodiekeUitkeringen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementPeriodiekeUitkeringen"
                                    id="rendementPeriodiekeUitkeringen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('kapitaalverzekeringen')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Kapitaalverzekeringen
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="kapitaalverzekeringen"
                                id="kapitaalverzekeringen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementKapitaalverzekeringen"
                                id="rendementKapitaalverzekeringen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementKapitaalverzekeringen"
                                    id="rendementKapitaalverzekeringen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('premieDepots')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Premiedepots
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="premieDepots"
                                id="premieDepots"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementPremieDepots"
                                id="rendementPremieDepots"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementPremieDepot"
                                    id="rendementPremieDepot"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('bouwDepots')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Bouwdepots
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="bouwDepots"
                                id="bouwDepots"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementBouwDepots"
                                id="rendementBouwDepots"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementBouwdepot"
                                    id="rendementBouwdepot"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('contantGeld')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Contant geld
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="contantGeld"
                                id="contantGeld"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementContantGeld"
                                id="rendementContantGeld"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementContantGeld"
                                    id="rendementContantGeld"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('overigeBezittingen')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Overige bezittingen
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="overigeBezittingen"
                                id="overigeBezittingen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementOverigeBezittingen"
                                id="rendementOverigeBezittingen"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementOverigeBezittingen"
                                    id="rendementOverigeBezittingen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('schuldenNederlandsOG')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: Schulden Nederlandse onroerende zaken
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="schuldenNederlandsOG"
                                id="schuldenNederlandsOG"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementSchuldenNederlandsOG"
                                id="rendementSchuldenNederlandsOG"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementSchuldenOgNederland"
                                    id="rendementSchuldenOgNederland"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('schuldenBuitenlandsOG')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: Schulden buitenlandse onroerende zaken
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="schuldenBuitenlandsOG"
                                id="schuldenBuitenlandsOG"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementSchuldenBuitenlandsOG"
                                id="rendementSchuldenBuitenlandsOG"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementSchuldenOgBuitenland"
                                    id="rendementSchuldenOgBuitenland"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('overigeSchulden')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: Overige schulden (na drempel)
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="schuldenNaDrempel"
                                id="overigeSchulden"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementAftrekbareSchulden"
                                id="rendementAftrekbareSchulden"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                        @if (heeftOwr) {
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="rendementSchuldenOgOverig"
                                    id="rendementSchuldenOgOverig"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        }
                    </div>
                    <div class="col-3"></div>
                </div>
            }

            <div class="row">
                <div class="col col-1">
                    <p>Rendementsgrondslag sparen en beleggen</p>
                </div>
                <div [formGroup]="formGroup" class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="rendementsGrondslag"
                            id="rendementsGrondslag"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
                <div class="col-3"></div>
            </div>

            @if (formGroup.get('heffingsvrijVermogenAangever')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: Heffingsvrij vermogen
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="heffingsvrijVermogenAangever"
                                id="heffingsvrijVermogenAangever"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-3"></div>
                </div>
            }

            @if (formGroup.get('heffingsvrijVermogenPartner')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: Heffingsvrij vermogen partner
                    </div>
                    <div [formGroup]="formGroup" class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="heffingsvrijVermogenPartner"
                                id="heffingsvrijVermogenPartner"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-3"></div>
                </div>
            }

            <div class="row">
                <div class="col col-1">
                    <p>Grondslag sparen en beleggen</p>
                </div>
                <div [formGroup]="formGroup" class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="grondslagSparenEnBeleggen"
                            id="grondslagSparenEnBeleggen"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
                <div class="col-3"></div>
            </div>
            <div class="row">
                <div class="col col-1">
                    Inkomen uit sparen en beleggen
                </div>
                <div [formGroup]="formGroup" class="col-2">
                    <snelstart-ui-number-form-control
                            [calculate]="berekenLaagsteVanRendementen()"
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="forfaitairRendement"
                            id="inkomenBox3"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="inkomenBox3"
                            id="inkomenBox3"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div [formGroup]="formGroupWerkelijkRendement" class="col-4">
                    @if (heeftOwr) {
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="werkelijkRendement"
                                id="werkelijkRendement"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    }
                </div>
                <div class="col-3"></div>
            </div>
        </form>

        <p class="pt-3" style="width: 75%">
            @if (heeftPartner) {
                <snelstart-ui-alert [showIcon]="true" type="info">
                    Het getoonde totale forfaitaire <b>rendement</b> is niet hetzelfde als het forfaitaire
                    <b>inkomen</b> uit sparen en beleggen. <br/>
                    Het forfaitaire inkomen uit sparen en beleggen wordt berekend door het aandeel in de grondslag sparen en beleggen
                    te delen door de rendementsgrondslag en daarna te vermenigvuldigen met het forfaitaire rendement.
                    Zie de berekeningen onderin deze applicatie.
                </snelstart-ui-alert>
            } @else {
                <snelstart-ui-alert [showIcon]="true" type="info">
                    Het getoonde totale forfaitaire <b>rendement</b> is niet hetzelfde als het forfaitaire
                    <b>inkomen</b>uit sparen en beleggen. <br/>
                    Het forfaitaire inkomen uit sparen en beleggen wordt berekend door de grondslag sparen en beleggen
                    te delen door de rendementsgrondslag en daarna te vermenigvuldigen met het forfaitaire rendement.
                    Zie de berekeningen onderin deze applicatie.
                </snelstart-ui-alert>
            }

        </p>

    } @else {
        <p>Er zijn geen vermogensbestanddelen in de aangifte ingevuld.</p>
    }
}

